import React from 'react';

import ClinicalLabMenu from './ClinicalLabMenu';
import PharmacyMenu from './PharmacyMenu';
import RadiologyMenu from './RadiologyMenu';
import NurseMenu from './NurseMenu';
import DoctorMenu from './DoctorMenu';
import ProcedureMenu from './ProcedureMenu';
import MyAccount from './MyAccount';
import TherapyMenu from './TherapyMenu';
import FrontDeskMenu from './FrontDeskMenu';

const MedicalDirectorMenu = () => {
	return (
		<>
			<li className="sub-header">
				<span>DOCTOR</span>
			</li>
			<DoctorMenu />
			<li className="sub-header">
				<span>FRONTDESK</span>
			</li>
			<FrontDeskMenu />
			<li className="sub-header">
				<span>NURSE</span>
			</li>
			<NurseMenu />
			<li className="sub-header">
				<span>MEDICAL LAB</span>
			</li>
			<ClinicalLabMenu />
			<li className="sub-header">
				<span>PHARMACY</span>
			</li>
			<PharmacyMenu />
			<li className="sub-header">
				<span>RADIOLOGY</span>
			</li>
			<RadiologyMenu />
			<li className="sub-header">
				<span>PROCEDURE</span>
			</li>
			<ProcedureMenu />
			<li className="sub-header">
				<span>THERAPY</span>
			</li>
			<TherapyMenu />
			<MyAccount />
		</>
	);
};

export default MedicalDirectorMenu;
